import { isAvailableStrict, FDealType, FOfferType } from '../../../../../packages/JsonQuery';
import { IFilterSet, TFilter } from 'shared/types/filters';

const OFFER_TYPE = FOfferType.FlatNew;

export const NEW_FLAT_FILTERS_SET: IFilterSet<TFilter>[] = [
  {
    availability: isAvailableStrict(FDealType.Sale, OFFER_TYPE),
    list: ['dealType', 'offerType', 'roomType', 'price', 'mortgageMonthlyPayment', 'advancedFilters', 'geo'],
  },
];
